/**
 * Re-exports Statsig server SDK helpers from `server/statsigServerConfig.ts` so
 * SSR and the custom Node server share one module instance (singleton).
 * The implementation lives under `server/` because Docker excludes `src/` from the runtime image.
 */
export * from '../../../server/statsigServerConfig'
